import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({
  container: {
    marginBottom: theme.spacing(1),
    color: "#8790A6",
    opacity: "0.8",
  },
});

const Message = (props) => {
  const { text, classes } = props;

  return (
    <div className={classes.container}>
      <Typography variant="subtitle1">{text}</Typography>
    </div>
  );
};

Message.propTypes = {
  text: PropTypes.string,
  time: PropTypes.object,
  name: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Message);
